// Son los tipos de acciones relacionadas a los comentarios

export default {
  data() {
    return {
      NEW_FILE: 1,
      UPDATED_FILE: 2,
      DELETED_FILE: 3,
      NEW_FOLDER: 4,
      UPDATED_FOLDER: 5,
      DELETED_FOLDER: 6
    };
  }
};
